module.exports = __webpack_public_path__ + "static/images/share_card.9463bcae1.png";